export { default } from './ModuleConfigOverview'
